<template>
  <div class="main">
    <van-checkbox
      @change="change"
      v-model="goldChecked"
      :name="gold"
      icon-size="23px"
      checked-color="#F15100"
    >
      <div class="content">
        <div v-if="useGold">
          <div>
            使用购物金<span class="gold-color">{{ payList.goldReduction }}</span
            >元，剩余
            <span class="gold-color"> {{ useGoldMoney() }}</span>
            元
          </div>
          <div class="gold-detail">
            <div class="gold-total">
              合计将使用<span class="gold-color">{{ goldlimi }}</span
              >个金币，剩余<span class="gold-color">{{ overPlusGold() }}</span
              >个金币
            </div>
          </div>
        </div>
        <div v-else>
          <div>
            您有折上折购物金<span class="gold-color">{{ goldMoney() }}</span
            >元可抵扣
          </div>
          <div class="gold-detail">
            <div class="gold-total">
              合计<span class="gold-color">{{ payList.totalGold }}</span
              >个金币可购物或提现
            </div>
          </div>
        </div>
      </div>
    </van-checkbox>
    <van-button type="default" @click="ruleClick" class="custom-style"
      >使用说明</van-button
    >
    <van-popup
      v-model="show"
      round
      position="bottom"
      :style="{ height: '42%' }"
    >
      <div class="pop-title">使用说明</div>
      <div class="pop-num">
        您拥有的折上折购物金:<image
          class="gold-icon"
          src="/static/mall/goldIcon.png"
        /><span class="gold-color">{{ goldMoney() }}</span
        ><span class="pop-total">(合计金币{{ payList.totalGold }}个)</span>
      </div>
      <div>
        <div class="rule-detail">
          <div>1.勾选使用金币后，将自动计量，扣除相应数量金币。</div>
          <div>2.折上折金币：100个金币等值人民币1元。</div>
          <div>3.金币可与其他优惠同步使用。</div>
          <div>4.已支付成功的订单，如退款，不返还金币。</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Decimal } from 'decimal.js'
export default {
  props: {
    payList: {
      type: Object,
    },
  },
  data() {
    return {
      goldlimi: '',
      useGold: false,
      gold: 'gold',
      goldChecked: false,
      radio: '0',
      show: false,
    }
  },
  methods: {
    changeGoldChecked() {
      this.goldChecked = false
    },
    goldMoney() {
      return new Decimal(this.payList.totalGold / 100)
    },
    useGoldMoney() {
      let goldCount = new Decimal(this.payList.totalGold / 100)
      return new Decimal(goldCount - this.payList.goldReduction)
    },
    overPlusGold() {
      return new Decimal(this.payList.totalGold - this.goldlimi)
    },
    change(val) {
      console.log('val', val)
      this.goldlimi = ''
      if (val) {
        if (this.payList.totalGold >= this.payList.maxUseGold) {
          this.goldlimi = this.payList.maxUseGold
        } else {
          this.goldlimi = this.payList.totalGold
        }
        this.useGold = true
        this.$emit('useGoldClick', this.goldlimi)
      } else {
        this.useGold = false
        this.$emit('zeroGoldClick', 0)
      }
    },
    ruleClick() {
      this.show = !this.show
    },
  },
}
</script>

<style scoped lang="less">
.custom-style {
  font-size: 8px;
  color: #007ed3 !important;
  border-color: #007ed3 !important;
  padding: 0 5px;
  width: 70px;
  height: 25px;
}

.main {
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  background-color: #fff;
  font-size: 15px;
  // width: 100%;
  .content {
    color: #595757;
    font-size: 15px;
    .gold-detail {
      width: 200px;
      .gold-total {
        width: 200px;
        font-size: 12px;
      }
    }
  }
  .gold-color {
    color: #f15100;
  }

  .gold-icon {
    vertical-align: middle;
    width: 17.5px;
    height: 17.5px;
  }

  .pop-title {
    text-align: center;
    padding-top: 15px;
    color: #007ed3;
  }
  .pop-num {
    text-align: center;
    padding: 20px 0 15px;
    color: #898989;
  }

  .pop-total {
    font-size: 12px;
    color: #898989;
  }

  .rule-detail {
    color: #898989;
    padding-left: 10px;
    div {
      padding: 5px 0;
    }
  }
}
/deep/.van-icon {
  color: white !important;
}
</style>
